//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import { createStore } from "vuex";
import Style from "./modules/style_module.js";
import Session from "./modules/session_module.js";
import Resolution from "./modules/resolution_module.js";
import Results from "./modules/results_module.js";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: { Style, Session, Resolution, Results },
});
